import { Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
// utils
import { cn } from '@/utils';

interface ButtonSpoilerProps {
    className?: string;
    children: React.ReactNode;
    showText: string;
    hideText: string;
}

const ButtonSpoiler = ({
    showText,
    hideText,
    className,
    children
}: ButtonSpoilerProps) => {
    const [isOpened, handlers] = useDisclosure(false);
    const handleToggle = () => {
        handlers.toggle();
    };
    return (
        <div className={cn(className)}>
            <Button
                className="mb-2"
                size="xs"
                variant="outline"
                onClick={handleToggle}
            >
                {isOpened ? hideText : showText}
            </Button>
            {isOpened ? <div>{children}</div> : undefined}
        </div>
    );
};

export default ButtonSpoiler;
